import { zivalService } from '../services/zival.service';
import Vue from 'vue'

const state = {
    zival: [],
    sezona:null,
    pridelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPridelovalecID', pridelovalecid)
      return zivalService.load(sezona,pridelovalecid)
            .then(
                zival => {
                  commit('load', zival);
                  if(makeEditable)
                  commit('makeEditable') 
                  return zival;                   
                } 
                
            );
    },
     loadPreteklaSezona({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
         dispatch('alert/clear', "",{ root: true });
        //commit('setSezona', sezona)
        //commit('setPridelovalecID', pridelovalecid)
        return new Promise((resolve, reject) => {

        
       zivalService.loadPreteklaSezona(sezona,pridelovalecid)
            .then(
                zival => {
                
                    zival.forEach(e=>{
                        e.id=null;
                        commit("add",e);
                    });

                  if(makeEditable)
                  commit('makeEditable') 
                  resolve(zival);                   
                },
                error =>{
                    console.log(error);
                    dispatch('alert/error', "Nalaganje ni uspelo", { root: true });
                    reject(error);
                }
                
            );
        });
    },

    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  zivalService.loadAll(sezona)
            .then(
                zival => commit('load', zival)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.zival.sezona;
        let pridelovalecid=this.state.zival.pridelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.zival.zival.forEach(item=>{
            item.sezona=sezona;
            item.pridelovalecid=pridelovalecid;
            console.log(item);
            if(!item.zivalid) {
                 item.saved=false;
                dispatch('alert/error', "Šifrant ni ustrezno izbran", { root: true });

            }
            else if(item.jeaktivna){
              zivalService.save(item)
               .then(
                zival => {
                 Vue.set(item,'saved',true);
                     Vue.set(item,'id',zival.id);
                     Vue.set(item,'jeaktivna',1);
                    
                },
                error => {
                    console.log(error);
                   Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             zivalService.save(item).then(
                zival => {
                 Vue.set(item,'saved',true);
                                      
                },
                error => {
                    console.log(error);
              Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, zival) {
        if(zival)
        state.zival=zival.map(k=>{
            k["veljavnostcertifikataod"]=kendo.parseDate(k["veljavnostcertifikataod"]) 

            let infonosilec=k.opomba?.split(";");
            if(Array.isArray(infonosilec)&&infonosilec.length==3){
                k.naslovnosilca=infonosilec[0];
                k.postnastevilkanosilca=infonosilec[2];
                k.postanosilca=infonosilec[1];
            }

            return k;
        }
            );   
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.zival.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.zival.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.zival.length;i++){
            let dateStr=state.zival[i].veljavnostcertifikataod;
            if(dateStr)
                state.zival[i].veljavnostcertifikataod=new Date(dateStr);
            else
                state.zival[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.zival[i], { inEdit: true });
            state.zival.splice(i,1,updated);
        }
        

    },
    setPridelovalecID(state, item) {
        state.pridelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.zival.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.zival.splice(index,1,updated);
            } else {
                let id = 1;
                state.zival.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.zival.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.zival.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.zival);
                state.zival.splice(index, 1);
        
        //    return data[index];
        //state.zival=data;

    },
    replace(state, zival) {
        state.zival = zival;
    }
   
};

export const zival = {
    namespaced: true,
    state,
    actions,
    mutations
};
